module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Black.c2915c3d.ttf";